import { makeStyles } from '@material-ui/core/styles';

const landingStyle = makeStyles({
  root: {
    minWidth: '1030px',
    maxWidth: '1680px',
    margin: '0px auto',
    padding: '0px 16px',
    backgroundColor: '#f3f3f3',
  },
});

export default landingStyle;
